// extracted by mini-css-extract-plugin
export var centerAligned = "TOskwTTe91S3SwZtWrP2";
export var info = "Qx0HxX0p0mvAZPuD79dD";
export var leftBorder = "KlObWp8sAia95fJSdXWt";
export var negative = "HWL9RKz2OjbTxp_6MRlW";
export var neutral = "jWUQDaLU7Fj8BsFo_wcO";
export var positive = "onNQf63ptL3UoGyVF2QU";
export var primary = "f1lDsCmpCoj2wr4SQitP";
export var root = "Pk1ElOGCVbRA7QUikUDS";
export var secondary = "S3jam3NDI3uhAfDRIsAR";
export var title = "SpQ_KT2CMDNIt2NNpfga";
export var warning = "j6bA6L4EZhmTlKC1O39v";
export var withChevron = "Pv3EOdhZDtyJ2oLRtmNw";